import { createReducer, on, Action } from '@ngrx/store';
import * as UserAuthActions from './userAuth.actions';
import { User } from '@app/core/interfaces';
import {ImpersonateSuccess} from "./userAuth.actions";

export const userAuthFeatureKey = 'userAuth';

export interface State {
  isAuthenticated: boolean;
  isImpersonating: boolean;
  user: User | null;
}

// TODO(bradley): Storing initial state using localstorage is needed here,
// but the important keys should probably be exported from somewhere else,
// Token storage service uses the "original token" key for impersonation
// as well so they should read from the same place in the future. Auth
// should also probably have initial state set, but we can come back to that.
// Right now I believe its just false on refresh but anywhere its checked
// also checks tokenstorageservice, when it should probably just check here.
export const initialState: State = {
  isAuthenticated: false,
  isImpersonating: false,
  user: null
};

const userAuthReducer = createReducer(
  initialState,
    on(UserAuthActions.ImpersonateSuccess, (state, action) => ({
      ...state,
      isImpersonating: true,
      isAuthenticated: true,
      user: action.response.user
    })),
    on(UserAuthActions.StopImpersonation, (state, action) => ({
      ...state,
      isImpersonating: false,
      isAuthenticated: true,
      user: action.user
    })),
    on(UserAuthActions.LoginFailure, (state, action) => ({
        ...state,
        isAuthenticated: false,
        isImpersonating: false,
        user: null
    })),
    on(UserAuthActions.ResetPasswordFailure, (state, action) => ({
        ...state,
        isAuthenticated: false,
        isImpersonating: false,
        user: null
    })),
    on(UserAuthActions.UpdateUserAuthDetails, (state, payload) => ({
        ...state,
        isAuthenticated: payload.isAuthenticated,
        isImpersonating: payload.isImpersonating,
        user: payload.user
    })),
    on(UserAuthActions.LogoutSuccess, (state, action) => ({
        ...state,
        isAuthenticated: false,
        isImpersonating: false,
        user: null
    })),
    on(UserAuthActions.SessionExpired, (state, action) => ({
      ...state,
      isAuthenticated: false,
      isImpersonating: false,
      user: null
    })),
    on(UserAuthActions.LogoutOnAlternateTab, (state, action) => ({
      ...state,
      isAuthenticated: false,
      isImpersonating: false,
      user: null
    })),
    on(UserAuthActions.EffectiveUserChanged, (state, action) => ({
      ...state,
      isAuthenticated: true,
      user: action.user
    }))
);

export function reducer(state: State | undefined, action: Action) {
  return userAuthReducer(state, action);
}
